import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import userProp from '../../../commonComponents/propTypes/userProp';
import DisplayShippingContainer from './DisplayShippingContainer/DisplayShippingContainer';

function OperatorInfo({
  t,
  user,
  onShippingChange,
  onAddShipping,
  onAddressOpen,
}) {
  const {
    image,
    firstName,
    lastName,
    username,
    address,
    email,
    phone,
    shippingAddress,
    shippingCountry,
    personalInfo,
  } = user;
  const isIndividual =
    !personalInfo?.businessType || personalInfo?.businessType === 'individual';
  // // Validations, check if all fields exist
  const userImage = image?.thumb ? image.thumb : '/images/no_user.png';
  const name = firstName && lastName ? `${firstName} ${lastName}` : username;

  const isBillingValid = useMemo(() => {
    if (!address) {
      return false;
    }

    let isValid = true;
    // Check if its individual or company if individual check the country code
    if (isIndividual) {
      // Check if address is valid according to shipping country
      if (shippingCountry) {
        isValid = shippingCountry === address?.countryCode;
      }
    }
    return isValid;
  }, [isIndividual, shippingCountry, address?.countryCode]);

  const addresses = useMemo(() => {
    const billingAddress = isBillingValid
      ? [
          {
            ...address,
            email,
            phone,
            companyName: !isIndividual ? personalInfo?.companyName : undefined,
            NIF: !isIndividual ? personalInfo?.NIF : undefined,
          },
        ]
      : [];

    return billingAddress.concat(shippingAddress || []);
  }, [
    address,
    email,
    phone,
    personalInfo?.companyName,
    personalInfo?.NIF,
    shippingAddress,
    isIndividual,
  ]);

  /** Render the component */
  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="row customer-img-name">
            <div>
              <img src={userImage} alt="/images/no_user.png" />
            </div>
            <p>{name}</p>
          </div>
          <div className="row customer-info-bill-email-phone">
            <div className="col-12">
              <div className="order-address-title-container">
                <p>{t('shop.cart.shipping')}</p>
              </div>
              <div className="customer-info-shipping-address">
                <DisplayShippingContainer
                  shipping={addresses}
                  onShippingChange={onShippingChange}
                  isShippingAddress
                  shippingCountry={shippingCountry}
                  user={user}
                  includesBilling={isBillingValid}
                  onAddShipping={onAddShipping}
                  onAddressOpen={onAddressOpen}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

OperatorInfo.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.shape(userProp.propType).isRequired,
  onShippingChange: PropTypes.func.isRequired,
  onAddShipping: PropTypes.func.isRequired,
  onAddressOpen: PropTypes.func.isRequired,
};

export default translate(OperatorInfo);
